export default "__VITE_ASSET__DLSZ7oGN__"